import { MachineStatusTypes } from "interfaces/machine-status-types";
import { useLazyFetchV2 } from "hooks/fetch/useLazyFetchV2";

interface LazyFetchResponse {
  count?: number;
  results?: MachineStatusTypes[];
}

interface LazyFetchFailureType {
  loading: boolean;
  error: boolean;
  fetchCallback: (url: string) => Promise<LazyFetchResponse>;
}

export const useLazyGetMachineStatusTypes = (): {
  loading: boolean;
  error: boolean;
  fetchMachineStatusTypes: (queryString?: string) => Promise<LazyFetchResponse>;
} => {
  const {
    loading,
    error,
    fetchCallback
  }: LazyFetchFailureType = useLazyFetchV2("GET");

  return {
    loading,
    error,
    fetchMachineStatusTypes: (queryString?: string) =>
      fetchCallback(`machine_status_types?${queryString ?? ""}`)
  };
};
